<div class="fixed inset-0 bg-gray-200/50 backdrop-blur-sm flex items-center justify-center z-50">
  <div
    class="bg-white dark:bg-gray-800 rounded-lg shadow-xl p-6 w-11/12 md:w-1/2 lg:w-1/3 max-h-[90vh] overflow-y-auto relative">
    <h2 class="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
      <span class="material-symbols-outlined"></span>Case Status Information
    </h2>
    <button (click)="close()"
      data-cy="page-caseDetails-button-closeStatusDialog"
      class="absolute top-4 right-4 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200">
      <span class="material-symbols-outlined">close</span>
    </button>
    <app-case-status-card [caseDetails$]="caseDetails$"></app-case-status-card>
  </div>
</div>